// Replaced on deployment to an environment with that environment's tag
export const GA_TRACKING_ID = "REPLACE-GA-TRACKING-ID"
